  document.addEventListener('DOMContentLoaded', function () {
    const variants = JSON.parse(document.getElementById('rw-variants-data').textContent);
    const typeInputs = document.querySelectorAll('input[name="Type"]');
    const optionsInputs = document.querySelectorAll('input[name="Options"]');

    typeInputs.forEach(typeInput => {
      typeInput.addEventListener('change', () => {
        const selectedType = typeInput.value;

        
        let matchedOption = null;

        for (const optionInput of optionsInputs) {
          if (optionInput.disabled) continue;
          const optionValue = optionInput.value;

          const matchedVariant = variants.find(variant =>
            variant.option1 === selectedType && variant.option2 === optionValue
          );

          if (matchedVariant) {
            matchedOption = optionInput;
            break;
          }
        }

     
        if (matchedOption) {
          matchedOption.checked = true;
          matchedOption.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

/*
const validValues = ["Online Stream", "Group Showing", "Playbook", "Playjector"];

const productInfo = document.querySelector(".product-info");
const rwContainer = document.querySelector(".rw-container");
const rwForm = rwContainer.querySelector(".rw-form");

const easifyOptionsWrapper = document.querySelector(".tpo_option-set-wrapper");

const matchingElements = Array.from(rwContainer.querySelectorAll('[name="Type"]'))
  .filter(el => validValues.includes(el.value));

const matchingLabels = matchingElements
  .map(el => document.querySelector(`label[for="${el.id}"]`))
  .filter(label => label !== null); // Filter out any nulls if label not found

matchingElements.forEach(inputEl => {
  const fieldset = inputEl.closest("fieldset");
  if (fieldset) {
    fieldset.style.display = "none";
  }
});

if (rwContainer) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE &&
            node.classList.contains("tpo_option-set-wrapper")
          ) {
            observer.disconnect();

            if (rwForm) {
              rwForm.prepend(node);
            }
            
            const event = new CustomEvent("easyfy:option-set:added", {
              detail: node,
            });
            rwContainer.dispatchEvent(event);
          }
        });
      }
    }
  });

  observer.observe(rwContainer, {
    childList: true,
    subtree: true, // optional, set to true if the target may be added deep within
  });
} else {
  console.warn("Element .rw-container not found.");
}

rwContainer.addEventListener("easyfy:option-set:added", (e) => {
  const optionSet = e.detail;
  const imageSwatchesWrapper = optionSet.querySelector(".tpo_option-type-image-swatches-wrapper");

  if (imageSwatchesWrapper) {
    const swatchInputs = imageSwatchesWrapper.querySelectorAll('[id^="_type-image-swatches-"]');

    swatchInputs.forEach((inputEl) => {
      const label = inputEl.closest("label");

      if (label) {
       label.addEventListener("click", () => {
        const inputValue = inputEl.value;
      
        const matchingIndex = matchingElements.findIndex(el => el.value === inputValue);
        if (matchingIndex !== -1) {
          const targetLabel = matchingLabels[matchingIndex];
      
          if (targetLabel) {
            targetLabel.click(); // simulate user click
      
            // Only update swatch selection if not already selected
            if (!label.classList.contains("tpo_is_checked_swatches")) {
              // Remove the class from all others
              imageSwatchesWrapper
                .querySelectorAll("label.tpo_is_checked_swatches")
                .forEach(lbl => lbl.classList.remove("tpo_is_checked_swatches"));
      
              // Apply to the clicked label
              label.classList.add("tpo_is_checked_swatches");
            }
          }
        }
        });
      }
    });

     const selectedValue = matchingElements.find(el => el.checked)?.value;
    if (selectedValue) {
      setSwatchSelectionByValue(imageSwatchesWrapper, swatchInputs, selectedValue);
    }
  }
});

function setSwatchSelectionByValue(wrapper, swatchInputs, selectedValue) {
  wrapper
    .querySelectorAll("label.tpo_is_checked_swatches")
    .forEach(lbl => lbl.classList.remove("tpo_is_checked_swatches"));

  swatchInputs.forEach((inputEl) => {
    if (inputEl.value === selectedValue) {
      const label = inputEl.closest("label");
      if (label) {
        label.classList.add("tpo_is_checked_swatches");
        label.click();
      }
    }
  });
}
*/
